import { Button } from "@/components/ui/button";
import { ArrowDown, TrendingUp } from "lucide-react";
import heroGarageImage from "@/assets/images/bisnisgarasi-hero.webp";
import heroGarageImageMobile from "@/assets/images/bisnisgarasi-hero_mobile.webp";

const HeroSection = () => {
  return (
    <section
      id="hero"
      className="relative isolate overflow-hidden bg-gradient-hero pb-24 pt-16 md:pt-24"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <picture>
          <source
            media="(max-width: 767px)"
            srcSet={heroGarageImageMobile}
          />
          <img
            src={heroGarageImage}
            alt="Workshop auto-care premium dengan pencahayaan industrial Scudetto"
            width={1920}
            height={1280}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            className="h-full w-full object-cover opacity-30"
          />
        </picture>
        <div className="absolute inset-0 bg-gradient-to-b from-background/60 via-background/70 to-background" />
      </div>

      <div className="container-narrow relative">
        <div className="mx-auto max-w-3xl text-center">
          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-accent/30 bg-accent/10 px-4 py-1.5 text-mono text-xs uppercase tracking-widest text-accent">
            <span className="h-1.5 w-1.5 rounded-full bg-accent animate-pulse" />
            Sistem Franchise Auto-Care Scudetto
          </div>

          <h1 className="heading-display text-5xl text-foreground sm:text-6xl md:text-7xl lg:text-8xl">
            Lahan Menganggur Anda{" "}
            <span className="text-accent">Menelan Jutaan</span>{" "}
            Setiap Bulan.
          </h1>

          <p className="mx-auto mt-8 max-w-2xl text-lg leading-relaxed text-muted-foreground md:text-xl">
            Berhenti melihat aset Anda tidur. Ubah garasi, lahan kosong, atau car wash
            yang stagnan menjadi unit bisnis auto-care premium dengan sistem
            <span className="font-semibold text-foreground"> plug-and-play teruji</span>.
          </p>

          <div className="mt-10 flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Button
              asChild
              size="lg"
              className="group bg-gradient-primary px-8 text-base font-semibold shadow-glow-primary transition-all hover:scale-[1.02] hover:opacity-95"
            >
              <a href="#lead-form">
                <TrendingUp className="mr-2 h-5 w-5" />
                Hitung Potensi Profit Saya
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-border bg-surface-elevated/50 text-base font-medium backdrop-blur hover:bg-surface-raised"
            >
              <a href="#solution">Pelajari Sistem Scudetto</a>
            </Button>
          </div>

          {/* Stat strip */}
          <div className="mx-auto mt-16 grid max-w-2xl grid-cols-3 gap-6 border-y border-border/60 py-6">
            <div>
              <div className="heading-display text-3xl text-primary md:text-4xl">120+</div>
              <div className="mt-1 text-mono text-xs uppercase tracking-wider text-muted-foreground">Mitra Aktif</div>
            </div>
            <div className="border-x border-border/60">
              <div className="heading-display text-3xl text-primary md:text-4xl">38%</div>
              <div className="mt-1 text-mono text-xs uppercase tracking-wider text-muted-foreground">Uplift F&B</div>
            </div>
            <div>
              <div className="heading-display text-3xl text-primary md:text-4xl">14<span className="text-xl">bln</span></div>
              <div className="mt-1 text-mono text-xs uppercase tracking-wider text-muted-foreground">Avg. Payback</div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex justify-center">
          <a href="#agitation" aria-label="Scroll ke bawah" className="text-muted-foreground transition-colors hover:text-primary">
            <ArrowDown className="h-6 w-6 animate-bounce" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
